"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var SvgGroupPaperclip = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, role: "img" }, props),
    React.createElement("path", { fill: "#666", fillRule: "evenodd", d: "m4.528 10.597 5.194-5.195c.752-.752 1.46-.045.707.707l-4.901 4.895-.703.71c-.797.806-1.736.824-2.337.23-.602-.595-.592-1.535.22-2.356L5.084 7.2l4.147-4.136c2.792-2.792 6.327.743 3.535 3.535L6.65 12.718l.707.707 6.119-6.119c3.734-3.734-1.215-8.684-4.95-4.95L4.05 6.822 1.996 8.885c-1.194 1.208-1.212 2.782-.211 3.77.96.949 2.45.958 3.613-.106l.2-.196L8.143 9.8l2.994-2.984C12.831 5.121 10.71 3 9.015 4.695L3.82 9.889l.707.708Z" }))); };
var Memo = (0, react_1.memo)(SvgGroupPaperclip);
exports.default = Memo;
//# sourceMappingURL=GroupPaperclip.js.map